export default {
  localeCode: window.global.LOCALE_CODE,
  phoneNumber: '',
  countryCode: 'sa',
  allowedCountries: ['sa', 'eg', 'in', 'bh', 'kw', 'ae', 'om'],
  stages: [
    { name: 'phone-number-input', active: true },
    { name: 'verification-code', active: false },
    { name: 'account-exist', active: false },
    { name: 'signup-form', active: false },
    { name: 'success', active: false }
  ],
  modalTarget: '',
  hasReadPictureGuide: false,
  hasReadCarPictureGuide: false,
  triggeredImageUploadElementId: '',
  isUpdateRequest: false,
  activeStep: {},
  formSteps: [
    {
      id: 1,
      title: 'static_form.courier_signup.screen_3.title',
      fields: [
        'citizenship',
        'national_id',
        'date_of_birth',
        'region',
        'city',
        'vehicle_type',
        'car_type',
        'car_number',
        'car_serial_number'
      ],
      active: false
    },
    {
      id: 2,
      title: 'static_form.courier_signup.screen_4.title',
      fields: [
        'profile_pic',
        'full_name',
        'email',
        'bank_name',
        'iban_no',
        'terms_and_conditions',
        'zahi'
      ],
      active: false
    },
    {
      id: 3,
      title: 'static_form.courier_signup.screen_5.title',
      fields: [
        'car_make',
        'car_model',
        'car_manufacturing_year',
        'sponsor_name',
        'id_image',
        'car_front_pic',
        'car_back_pic',
        'driver_license',
        'id_image_back',
        'vehicle_registration_front_image',
        'vehicle_registration_back_image',
        'vehicle_full_view_image'
      ],
      active: false
    }
  ],

  showField (fieldName, countryCode = '') {
    const isEnabledForCountry = countryCode ? (this.countryCode === countryCode) : true
    return this.activeStep.fields.includes(fieldName) && isEnabledForCountry
  },

  getActiveStage () { return this.stages.find((stage) => stage.active) },

  setActiveStage (name) {
    this.stages = this.stages.map((stage) => {
      return { ...stage, active: stage.name === name }
    })
  },

  setActiveFormStep (step) {
    if (typeof step === 'number') {
      this.activeStep = this.formSteps[step]
      this.formSteps = this.formSteps.map((stage) => ({ ...stage, active: stage.id === step + 1 }))
    } else {
      this.activeStep = {
        title: 'static_form.courier_signup.screen_5.sub_title_1',
        fields: [...step]
      }
      this.isUpdateRequest = true
    }
  },

  getActiveFormStep () { return this.formSteps.findIndex((step) => step.active === true) }
}
